<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div *ngIf="token">
    <section>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-7">
            <h4 style="float:right;">
              Promo Code List History
            </h4>
          </div>

          <div class="col-lg-5">
            <button class="btn btn-primary" (click)="Back()" style="float:right;">Back</button>

          </div>

        </div>
        <hr class="hr-border" />
      </div>
    </section>


    <section>



      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">

            <p *ngIf="total_count===0">
              <strong>Sorry!</strong> No record found!.
            </p>
            <br />
            <div *ngIf="total_count>0">
              <table class="table table-hover text-center table-bordered table-responsive" border="1">
                <thead class="theme-button text-white">
                  <tr>


                    <th scope="col">Promo Code</th>
                    <th scope="col">Promo Code Amount</th>
                    <th scope="col">Promo Code IsUsed</th>
                    <th scope="col">Promo Code Expiry Date & Time </th>

                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let x of PromoListdetailList">
                    <td class="accept">
                      <span>

                        <button type="button" class="btn btn-primary" (click)="copyToClipboard(x.Code)">
                          Copy
                        </button>
                        &nbsp; &nbsp;
                        {{x.Code}}
                      </span>
                    </td>

                    <td class="accept">
                      <span> {{x.Amount}} INR </span>
                    </td>

                    <td class="accept">
                      <span>{{x.IsUsed===true?'Used':'Unused'}} </span>
                    </td>

                    <td class="accept">
                      <span> {{x.ExpiryDate| date :'medium' }}</span>
                    </td>

                  </tr>

                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
      <div class="pagenation-wrapper" *ngIf="total_count>0">
        <mat-paginator [length]="total_count" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" #paginator
                       (page)="handle($event)">
        </mat-paginator>
      </div>
    </section>
  </div>
</fieldset>
